import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=2583943c&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./edit.vue?vue&type=style&index=1&id=2583943c&scoped=true&lang=css&"
import style2 from "./edit.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2583943c",
  null
  
)

export default component.exports